/* ============================================================
   EPICLABS® APP CONTROLLER  v3.0 — robusto y simple
   - Desbloqueo local (Face ID / nombre / cuenta Shopify)
   - Estado por clase en <html> (epic-unlocked / epic-locked)
   - Navegación por accesos directos (scroll suave, confiable)
   - PDF con marca
   ============================================================ */
(function(){
  if (window.EpicApp) return;

  function lsGet(k, d){ try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch(e){ return d; } }
  function lsSet(k, v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch(e){} }

  var API = {
    member: function(){ return lsGet('epicMember', null); },
    isUnlocked: function(){
      if (document.documentElement.getAttribute('data-epic-customer') === '1') return true;
      try { if (localStorage.getItem('epic_master_unlock') === '1') return true; } catch(e){}
      /* Desbloqueo LOCAL legítimo — MISMO criterio que el anti-flash de epic-progress.liquid:
         epicAppUnlocked + un miembro reconocido (con nombre .f). El logout (lock()) limpia
         ambos, así que esto NO revela el panel tras cerrar sesión (ese era el miedo del flag
         huérfano). Sin esto, "Entrar a mi app"/Face ID escribía el flag pero reveal() lo
         negaba → el usuario se quedaba atascado en el login pese a entrar. */
      try {
        var unlocked = JSON.parse(localStorage.getItem('epicAppUnlocked') || 'false') === true;
        var mem = JSON.parse(localStorage.getItem('epicMember') || 'null');
        if (unlocked && mem && mem.f) return true;
      } catch(e){}
      return false;
    },
    unlock: function(member){
      if (member) lsSet('epicMember', member);
      lsSet('epicAppUnlocked', true);
      reveal();
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch(e){}
      document.dispatchEvent(new CustomEvent('epic:app:unlock', { detail: API.member() }));
    },
    lock: function(){ try { ['epicAppUnlocked','epicMember','epic_master_unlock','epic_member_v1'].forEach(function(k){ localStorage.removeItem(k); }); } catch(e){} location.reload(); },
    goTo: function(sel){
      var t = document.querySelector(sel); if (!t) return;
      var nav = document.querySelector('.epic-an');
      var off = (nav ? nav.offsetHeight : 0) + 14;
      var y = t.getBoundingClientRect().top + window.pageYOffset - off;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
  };

  function reveal(){
    var on = API.isUnlocked();
    var root = document.documentElement;
    var isCust = root.getAttribute('data-epic-customer') === '1';
    root.classList.toggle('epic-unlocked', on);
    root.classList.toggle('epic-locked', !on);
    /* Modo LOCAL: desbloqueado pero sin sesión Shopify viva */
    root.classList.toggle('epic-local', on && !isCust);
    if (on && !isCust) { try { hydrateLocal(); } catch(e){} }

    /* Mostrar/ocultar contenido protegido + candados */
    document.querySelectorAll('[data-epic-protected]').forEach(function(el){ el.hidden = !on; });
    document.querySelectorAll('[data-epic-gate]').forEach(function(el){ el.hidden = on; });

    /* Dashboard vs pantalla de login */
    var dash = document.querySelector('[data-epic-dash]');
    var unlock = document.querySelector('[data-epic-unlock]');
    if (dash) dash.hidden = !on;
    if (unlock) unlock.hidden = on;

    /* Barra de accesos directos solo cuando está desbloqueada */
    var nav = document.querySelector('.epic-an');
    if (nav) nav.style.display = on ? '' : 'none';
  }

  /* ── Modo LOCAL: desbloqueado sin sesión Shopify viva ──
     El panel se renderiza en el servidor con "atleta" + $0 porque no hay customer.
     Aquí hidratamos el nombre real (epicMember.f) y mostramos un acceso para conectar
     la cuenta. CSS (html.epic-local) oculta los KPIs/bloques que dependen de Shopify. */
  var _hydrated = false;
  function hydrateLocal(){
    if (_hydrated) return;
    var mem = API.member();
    if (!mem || !mem.f) return;
    _hydrated = true;
    var esc = function(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); };
    var isFrida = (mem.e || '').toLowerCase() === 'fridacardenas71@gmail.com';
    var disp = isFrida ? 'Mi Amor' : mem.f;
    /* Saludo del panel — nunca "atleta" */
    var hi = document.querySelector('[data-epic-hi]');
    if (hi) hi.innerHTML = isFrida
      ? 'Bienvenida, <em>Mi Amor</em> 💙'
      : 'Épico día, <em>' + esc(disp) + '</em>.';
    /* El "Cerrar sesión" no aplica sin sesión Shopify: lo ocultamos */
    var lo = document.querySelector('[data-epic-logout]');
    if (lo) lo.hidden = true;
    /* Mostrar banner para conectar la cuenta (pedidos/nivel/recompensas) */
    var cb = document.querySelector('[data-epic-connect]');
    if (cb) cb.hidden = false;
  }

  /* ── PDF Builder premium con marca EPIC ──
     EpicPDF.print(title, innerHTML, opts)
     Genera un PDF REAL (archivo) y abre la hoja de compartir nativa de iOS
     (WhatsApp, Guardar en Archivos…) o lo descarga directo en escritorio.
     Si falla, cae a la vista de impresión clásica.
     opts = { subtitle, level, accent, meta:[...], note, macros } */
  var ISOTIPO = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">'
    + '<rect x="3" y="13" width="4.2" height="8" rx="1.4" fill="#fff"/>'
    + '<rect x="9.9" y="8" width="4.2" height="13" rx="1.4" fill="#fff"/>'
    + '<rect x="16.8" y="3" width="4.2" height="18" rx="1.4" fill="#fff"/></svg>';

  function epdCSS(accent){
    /* Todo scopeado a .epd para no contaminar la página al renderizar */
    return ''
      + '.epd *{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact;}'
      + '.epd{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;color:#0E1B4D;line-height:1.5;background:#fff;width:794px;}'
      + '.epd .wrap{padding:0 40px 40px;}'
      + '.epd .cover{background:linear-gradient(135deg,#0E1B4D 0%,#16245F 55%,'+accent+' 140%);color:#fff;padding:38px 40px 30px;position:relative;overflow:hidden;}'
      + '.epd .cover::after{content:"";position:absolute;top:-80px;right:-60px;width:300px;height:300px;border-radius:50%;background:radial-gradient(circle,rgba(91,160,255,.35),transparent 65%);}'
      + '.epd .brand{display:flex;align-items:center;gap:12px;position:relative;}'
      + '.epd .brand .m{width:46px;height:46px;border-radius:13px;background:rgba(255,255,255,.14);border:1px solid rgba(255,255,255,.22);display:flex;align-items:center;justify-content:center;}'
      + '.epd .brand .bn{font-size:13px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;opacity:.92;}'
      + '.epd .brand .bd{font-size:10.5px;opacity:.7;letter-spacing:.04em;}'
      + '.epd h1{font-size:27px;line-height:1.15;margin:20px 0 6px;letter-spacing:-.02em;font-weight:800;position:relative;}'
      + '.epd .sub{font-size:13px;opacity:.82;margin:0;position:relative;max-width:80%;}'
      + '.epd .lvl{display:inline-block;margin-top:14px;background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.28);color:#fff;font-size:11px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;padding:6px 13px;border-radius:100px;position:relative;}'
      + '.epd .meta{display:flex;flex-wrap:wrap;gap:8px;margin-top:14px;position:relative;}'
      + '.epd .meta span{font-size:11px;font-weight:600;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.2);padding:5px 11px;border-radius:8px;}'
      + '.epd h2{font-size:16px;margin:26px 0 10px;color:#0E1B4D;font-weight:800;letter-spacing:-.01em;padding-left:12px;border-left:4px solid '+accent+';line-height:1.25;}'
      + '.epd h3{font-size:13.5px;margin:14px 0 4px;font-weight:700;color:#16245F;}'
      + '.epd p{font-size:13px;margin:6px 0;}'
      + '.epd ul{margin:6px 0 12px;padding-left:4px;list-style:none;} .epd li{font-size:13px;margin:5px 0;line-height:1.45;padding-left:20px;position:relative;}'
      + '.epd li::before{content:"";position:absolute;left:2px;top:7px;width:7px;height:7px;border-radius:50%;background:'+accent+';}'
      + '.epd .card{border:1px solid #E6E9F2;border-radius:14px;padding:16px 18px;margin-bottom:12px;background:#FBFCFE;page-break-inside:avoid;break-inside:avoid;}'
      + '.epd .card h2,.epd .card h3{margin-top:0;}'
      + '.epd img{max-width:100%;border-radius:10px;}'
      + '.epd table{width:100%;border-collapse:collapse;font-size:12.5px;margin:8px 0 12px;}'
      + '.epd th,.epd td{text-align:left;padding:8px 10px;border-bottom:1px solid #EAEDF4;} .epd th{color:#6B7191;font-size:10.5px;text-transform:uppercase;letter-spacing:.04em;}'
      + '.epd pre{white-space:pre-wrap;font-family:inherit;font-size:12.5px;margin:0;}'
      + '.epd .disc{margin:26px 0 0;padding:14px 16px;background:#F4F7FE;border:1px solid #E1E8F7;border-radius:12px;font-size:11.5px;color:#5A6085;line-height:1.5;}'
      + '.epd .ftin{margin-top:20px;padding:12px 40px;border-top:1px solid #E5E7F0;color:#6B7191;font-size:10px;display:flex;justify-content:space-between;}'
      + '.epd .mz{display:flex;align-items:center;gap:22px;margin:18px 0 6px;padding:18px 20px;border:1px solid #E6E9F2;border-radius:16px;background:#fff;page-break-inside:avoid;break-inside:avoid;}'
      + '.epd .mz-legend{display:flex;flex-direction:column;gap:8px;font-size:12.5px;color:#16245F;}'
      + '.epd .mz-legend div{display:flex;align-items:center;gap:9px;} .epd .mz-legend i{width:11px;height:11px;border-radius:3px;display:inline-block;flex:0 0 auto;} .epd .mz-legend b{color:#0E1B4D;}'
      + '.epd .epic-mc__diet-head h3{font-size:15px;margin:0 0 2px;color:#0E1B4D;font-weight:800;} .epd .epic-mc__diet-head p{font-size:12px;color:#5A6085;margin:0 0 12px;}'
      + '.epd .epic-mc__days{display:flex;flex-direction:column;gap:12px;}'
      + '.epd .epic-mc__day{border:1px solid #E6E9F2;border-radius:14px;padding:14px 16px;background:#FBFCFE;page-break-inside:avoid;break-inside:avoid;}'
      + '.epd .epic-mc__day-tag{display:inline-block;font-size:9.5px;font-weight:800;letter-spacing:.08em;color:#1A6BF5;background:rgba(26,107,245,.1);padding:3px 9px;border-radius:100px;text-transform:uppercase;}'
      + '.epd .epic-mc__day-title{font-size:14px;font-weight:800;color:#0E1B4D;margin:8px 0 6px;}'
      + '.epd .epic-mc__meal{border-top:1px solid #EEF1F8;padding:9px 0;} .epd .epic-mc__meal:first-of-type{border-top:0;}'
      + '.epd .epic-mc__meal-head{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:4px;}'
      + '.epd .epic-mc__meal-left{display:flex;align-items:center;gap:10px;}'
      + '.epd .epic-mc__meal-photo{width:38px;height:38px;border-radius:9px;object-fit:cover;}'
      + '.epd .epic-mc__meal-ph{width:38px;height:38px;border-radius:9px;display:flex;align-items:center;justify-content:center;background:rgba(26,107,245,.1);color:#1A6BF5;}'
      + '.epd .epic-mc__meal b{font-size:12.5px;font-weight:700;color:#0E1B4D;}'
      + '.epd .epic-mc__meal ul{margin:2px 0 0;padding-left:0;} .epd .epic-mc__meal li{font-size:12px;color:#46506E;padding-left:16px;} .epd .epic-mc__meal li::before{width:5px;height:5px;top:7px;background:#cdd6ea;}'
      + '.epd .epic-mc__recipe{margin-top:8px;border:1px solid #E6E9F2;border-radius:10px;overflow:hidden;} .epd .epic-mc__recipe summary{list-style:none;padding:8px 11px;font-size:12px;font-weight:700;color:#1A6BF5;} .epd .epic-mc__recipe ol{padding:8px 12px 10px 26px;} .epd .epic-mc__recipe li{font-size:12px;color:#0E1B4D;}'
      + '.epd .epic-mc__day-total{display:flex;justify-content:space-between;margin-top:8px;padding-top:8px;border-top:1px dashed #E1E8F7;font-size:12px;color:#5A6085;} .epd .epic-mc__day-total b{color:#0E1B4D;}';
  }

  function macroDonut(m){
    var pc=(m.prot||0)*4, cc=(m.carb||0)*4, fc=(m.fat||0)*9, tot=pc+cc+fc||1;
    var pp=pc/tot, cp=cc/tot, fp=fc/tot, C=2*Math.PI*42;
    function seg(frac, off, color){
      return '<circle cx="60" cy="60" r="42" fill="none" stroke="'+color+'" stroke-width="16" stroke-dasharray="'+(frac*C).toFixed(1)+' '+((1-frac)*C).toFixed(1)+'" stroke-dashoffset="'+(-off*C).toFixed(1)+'" transform="rotate(-90 60 60)"/>';
    }
    return '<div class="mz"><svg width="120" height="120" viewBox="0 0 120 120" aria-hidden="true">'
      + '<circle cx="60" cy="60" r="42" fill="none" stroke="#EEF1F8" stroke-width="16"/>'
      + seg(pp,0,'#1A6BF5') + seg(cp,pp,'#5BA0FF') + seg(fp,pp+cp,'#F59E0B')
      + '<text x="60" y="57" text-anchor="middle" font-size="21" font-weight="800" fill="#0E1B4D">'+(m.kcal||0)+'</text>'
      + '<text x="60" y="73" text-anchor="middle" font-size="9" fill="#6B7191">kcal / día</text></svg>'
      + '<div class="mz-legend">'
        + '<div><i style="background:#1A6BF5"></i>Proteína <b>'+(m.prot||0)+' g</b> · '+Math.round(pp*100)+'%</div>'
        + '<div><i style="background:#5BA0FF"></i>Carbohidratos <b>'+(m.carb||0)+' g</b> · '+Math.round(cp*100)+'%</div>'
        + '<div><i style="background:#F59E0B"></i>Grasas <b>'+(m.fat||0)+' g</b> · '+Math.round(fp*100)+'%</div>'
      + '</div></div>';
  }

  function buildBody(title, innerHTML, opts, accent, date){
    var levelPill = opts.level ? '<span class="lvl">'+esc(opts.level)+'</span>' : '';
    var metaHtml = (opts.meta && opts.meta.length) ? '<div class="meta">'+opts.meta.map(function(x){ return '<span>'+esc(x)+'</span>'; }).join('')+'</div>' : '';
    var note = opts.note || 'Plan orientativo basado en tus respuestas. Ajusta a tu progreso y consulta a un profesional de la salud.';
    // FIX página blanca: solo render macroDonut si EXISTE y skipMacros NO está activo
    var macroViz = (opts.macros && !opts.skipMacros) ? macroDonut(opts.macros) : '';
    // Cover compacto: padding reducido para que no empuje contenido a página 2 sola
    return '<div class="epd">'
      + '<header class="cover" style="padding:24px 36px 22px;page-break-after:avoid;break-after:avoid;"><div class="brand"><div class="m">'+ISOTIPO+'</div><div><div class="bn">EPIC LABS®</div><div class="bd">Aplicación EPIC · '+date+'</div></div></div>'
        + '<h1 style="margin:14px 0 4px;">'+esc(title)+'</h1>'
        + (opts.subtitle ? '<p class="sub">'+esc(opts.subtitle)+'</p>' : '') + levelPill + metaHtml
      + '</header>'
      + '<main class="wrap" style="padding:0 36px 30px;">' + macroViz + innerHTML
        + '<div class="disc"><b>Nota:</b> '+esc(note)+'</div>'
        + '<div class="ftin"><span>EPIC LABS® · epiclabs.mx</span><span>Generado por tu Aplicación EPIC</span></div>'
      + '</main></div>';
  }

  function loadHtml2pdf(cb){
    if (window.html2pdf) return cb(true);
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.2/html2pdf.bundle.min.js';
    s.onload = function(){ cb(!!window.html2pdf); };
    s.onerror = function(){ cb(false); };
    document.head.appendChild(s);
  }

  function slugify(t){ return String(t||'plan-epic').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,48) || 'plan-epic'; }

  /* Documento imprimible/descargable: SIEMPRE renderiza (no se queda en blanco).
     Lleva una barra clara (solo en pantalla) para que se entienda que se Guarda/Comparte;
     en iPhone, "Guardar" abre Imprimir → Guardar en Archivos o Compartir (WhatsApp). */
  function openPrintDoc(title, bodyHtml, css){
    var w = window.open('', '_blank');
    if (!w){ alert('Permite ventanas emergentes para descargar tu PDF.'); return; }
    var bar = '<div class="epd-bar">'
      + '<div class="epd-bar__txt"><b>Tu PDF EPIC está listo</b><span>Toca <b>Guardar PDF</b> y elige <b>Guardar en Archivos</b> o <b>Compartir</b> (WhatsApp).</span></div>'
      + '<button type="button" class="epd-bar__btn" onclick="window.print()">⬇️ Guardar PDF</button>'
      + '</div>';
    var barCss = '@media screen{.epd-bar{position:sticky;top:0;z-index:9;display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;'
      + 'background:#0E1B4D;color:#fff;padding:12px 18px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}'
      + '.epd-bar__txt{display:flex;flex-direction:column;gap:1px;} .epd-bar__txt b{font-size:13.5px;font-weight:800;} .epd-bar__txt span{font-size:11.5px;opacity:.85;}'
      + '.epd-bar__txt span b{opacity:1;color:#7FB0FF;font-weight:700;}'
      + '.epd-bar__btn{appearance:none;border:0;border-radius:11px;background:#fff;color:#0E1B4D;font-weight:800;font-size:13.5px;padding:11px 18px;min-height:46px;cursor:pointer;white-space:nowrap;}}'
      + '@media print{.epd-bar{display:none!important;}}';
    w.document.write('<!doctype html><html lang="es"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>'+esc(title)+' · EPIC LABS</title><style>'+css+' body{margin:0;background:#fff;} '+barCss+'</style></head><body>'+bar+bodyHtml+'</body></html>');
    w.document.close(); w.focus();
    /* En desktop dispara el diálogo de impresión/guardar; en iOS el usuario toca el botón */
    setTimeout(function(){ try { if (!/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) w.print(); } catch(e){} }, 500);
  }

  /* ── Loader a pantalla completa mientras se genera el PDF ── */
  function pdfLoader(){
    var ov = document.createElement('div');
    ov.setAttribute('data-epd-loading','');
    ov.style.cssText = 'position:fixed;inset:0;z-index:2147483600;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;'
      + 'background:rgba(8,14,40,.86);-webkit-backdrop-filter:none;backdrop-filter:none;color:#fff;'
      + 'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;';
    ov.innerHTML = '<div style="width:54px;height:54px;border-radius:50%;border:3px solid rgba(255,255,255,.2);border-top-color:#2E7BFF;animation:epdSpin .8s linear infinite;"></div>'
      + '<div style="font-size:14px;font-weight:700;letter-spacing:.01em;">Generando tu PDF EPIC…</div>'
      + '<div style="font-size:12px;opacity:.7;">Un momento, preparando el documento.</div>'
      + '<style>@keyframes epdSpin{to{transform:rotate(360deg)}}</style>';
    document.body.appendChild(ov);
    return ov;
  }

  /* Espera a que carguen fuentes e imágenes del documento antes de capturar (evita PDF en blanco) */
  function waitReady(root, cb){
    var done = false, finish = function(){ if (done) return; done = true; cb(); };
    var imgs = Array.prototype.slice.call(root.querySelectorAll('img'));
    var pending = imgs.length;
    var fontsP = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    function maybe(){ if (pending <= 0) fontsP.then(function(){ setTimeout(finish, 60); }); }
    if (!imgs.length) { maybe(); }
    imgs.forEach(function(img){
      if (img.complete && img.naturalWidth) { pending--; maybe(); return; }
      img.addEventListener('load', function(){ pending--; maybe(); }, { once:true });
      img.addEventListener('error', function(){ pending--; maybe(); }, { once:true });
    });
    setTimeout(finish, 3500); /* tope de seguridad: nunca se cuelga */
  }

  /* Genera y DESCARGA un archivo .pdf real directo (sin ventana de imprimir ni hoja de compartir).
     Si el dispositivo o la librería fallan, cae al documento imprimible clásico. */
  function downloadPdf(title, bodyHtml, css){
    loadHtml2pdf(function(ok){
      if (!ok) { openPrintDoc(title, bodyHtml, css); return; }
      var ov = pdfLoader();
      var host = document.createElement('div');
      /* En pantalla (no display:none) para que el navegador renderice todo, pero invisible bajo el loader */
      host.style.cssText = 'position:fixed;left:0;top:0;width:794px;z-index:1;opacity:0;pointer-events:none;';
      host.innerHTML = '<style>'+css+'</style>' + bodyHtml;
      document.body.appendChild(host);
      var target = host.querySelector('.epd') || host;
      function cleanup(){ try{ host.remove(); }catch(e){} try{ ov.remove(); }catch(e){} }
      var fname = slugify(title) + '-epic.pdf';
      /* Descarga directa a Archivos (sin redirigir ni abrir el PDF en la web) */
      function dl(blob){
        try {
          var url = URL.createObjectURL(blob);
          var a = document.createElement('a'); a.href = url; a.download = fname; a.rel = 'noopener';
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(function(){ try{ URL.revokeObjectURL(url); }catch(e){} }, 5000);
        } catch (e) { openPrintDoc(title, bodyHtml, css); }
      }
      waitReady(host, function(){
        try {
          window.html2pdf().set({
            margin: 0,
            filename: fname,
            image: { type: 'jpeg', quality: 0.96 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: false, backgroundColor: '#ffffff', windowWidth: 794, scrollX: 0, scrollY: 0, logging: false },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
            // FIX página blanca: respeta page-break-before y avoid-all combinados correctamente
            pagebreak: { mode: ['css', 'legacy'], before: '.pdoc-newpage', avoid: ['.pdoc-page', '.pdoc-card', '.pdoc-session', 'tr', 'table'] }
          }).from(target).outputPdf('blob')
            .then(function(blob){
              cleanup();
              var file;
              try { file = new File([blob], fname, { type: 'application/pdf' }); } catch (e) { file = null; }
              /* Botón = SHARE nativo: guardar en Archivos o mandar por WhatsApp. Si no se puede, descarga directo. */
              if (file && navigator.canShare && navigator.canShare({ files: [file] }) && navigator.share) {
                navigator.share({ files: [file], title: title, text: 'Tu plan EPIC LABS®' })
                  .catch(function(){ dl(blob); });
              } else {
                dl(blob);
              }
            })
            .catch(function(){ cleanup(); openPrintDoc(title, bodyHtml, css); });
        } catch (e) { cleanup(); openPrintDoc(title, bodyHtml, css); }
      });
    });
  }

  window.EpicPDF = {
    print: function(title, innerHTML, opts){
      opts = opts || {};
      var accent = opts.accent || '#1A6BF5';
      var date = new Date().toLocaleDateString('es-MX',{ day:'numeric', month:'long', year:'numeric' });
      var css = epdCSS(accent);
      var bodyHtml = buildBody(title, innerHTML, opts, accent, date);
      downloadPdf(title, bodyHtml, css);
    }
  };

  function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  /* ── Instalar app (PWA) · reutilizable en todo el sitio ──
     Botones con [data-epic-install-app] llaman a esto. */
  var __iprompt = null;
  window.addEventListener('beforeinstallprompt', function(e){ e.preventDefault(); __iprompt = e; document.documentElement.classList.add('epic-can-install'); });
  window.addEventListener('appinstalled', function(){ __iprompt = null; try { localStorage.setItem('epicInstallDismissed','1'); } catch(e){} document.documentElement.classList.add('epic-installed'); });

  API.isStandalone = function(){ return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || navigator.standalone === true; };
  API.installApp = function(){
    if (API.isStandalone()) { installToast('Ya tienes EPIC en tu inicio ✓'); return; }
    if (__iprompt) {
      __iprompt.prompt();
      __iprompt.userChoice.then(function(c){ if (c && c.outcome === 'accepted') { document.documentElement.classList.add('epic-installed'); } __iprompt = null; });
      return;
    }
    installSheet();
  };

  function installToast(msg){
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);z-index:100020;background:#0E1B4D;color:#fff;padding:12px 18px;border-radius:100px;font:600 13px/-apple-system,sans-serif;box-shadow:0 10px 30px rgba(14,27,77,.4);opacity:0;transition:opacity .3s ease,transform .3s ease;';
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.style.opacity='1'; });
    setTimeout(function(){ t.style.opacity='0'; t.style.transform='translateX(-50%) translateY(8px)'; setTimeout(function(){ t.remove(); }, 320); }, 2400);
  }

  function installSheet(){
    if (document.getElementById('epic-install-sheet')) return;
    var ua = navigator.userAgent || '';
    var isIOS = /iphone|ipad|ipod/i.test(ua);
    var inApp = /(instagram|fbav|fban|fb_iab|tiktok|musical_ly|line\/)/i.test(ua);
    var ol = 'margin:0;padding-left:22px;display:flex;flex-direction:column;gap:11px';
    var iosSafari = '<ol style="'+ol+'"><li>Toca <b>Compartir</b> ↑ (en la barra de abajo de Safari).</li><li>Desliza y elige <b>“Agregar a inicio”</b>.</li><li>Confirma con <b>Agregar</b>. ✓</li></ol>';
    var iosInApp = '<ol style="'+ol+'"><li>Toca los <b>•••</b> abajo a la derecha.</li><li>Toca el botón <b>Compartir</b> (↗).</li><li>Toca <b>“Ver más / ▾”</b> (la flechita).</li><li>Elige <b>“Agregar a pantalla de inicio”</b>. ✓</li></ol><p style="margin:10px 0 0;font:400 12px/1.5 -apple-system,sans-serif;color:#5A6085">Si no aparece, abre <b>epiclabs.mx</b> en <b>Safari</b> y repite.</p>';
    var ios = inApp ? iosInApp : iosSafari;
    var and = '<ol style="'+ol+'"><li>Toca el menú <b>⋮</b> (arriba a la derecha).</li><li>Elige <b>“Instalar app” / “Agregar a pantalla principal”</b>.</li><li>Confirma. ✓</li></ol>';
    var ov = document.createElement('div');
    ov.id = 'epic-install-sheet';
    ov.style.cssText = 'position:fixed;inset:0;z-index:100020;background:rgba(8,12,30,.6);-webkit-backdrop-filter:none;backdrop-filter:none;display:flex;align-items:flex-end;justify-content:center;opacity:0;transition:opacity .3s ease;';
    ov.innerHTML = '<div style="background:#fff;width:100%;max-width:460px;border-radius:24px 24px 0 0;padding:26px 24px calc(26px + env(safe-area-inset-bottom));box-shadow:0 -10px 40px rgba(14,27,77,.3);transform:translateY(20px);transition:transform .35s cubic-bezier(.16,1,.3,1);font-family:-apple-system,Segoe UI,sans-serif" data-sheet>'
      + '<div style="width:42px;height:5px;border-radius:5px;background:#E0E4F0;margin:0 auto 18px"></div>'
      + '<div style="display:flex;align-items:center;gap:12px;margin-bottom:14px"><div style="width:46px;height:46px;border-radius:13px;background:linear-gradient(160deg,#1A6BF5,#0E1B4D);color:#fff;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:24px">E</div><div><div style="font:800 16px/1.2 -apple-system,sans-serif;color:#0E1B4D">Instala EPIC en tu inicio</div><div style="font:400 12.5px/1.3 -apple-system,sans-serif;color:#5A6085">Acceso de 1 toque, como app real</div></div></div>'
      + '<div style="font:400 14px/1.5 -apple-system,sans-serif;color:#16245F;background:#F4F7FE;border:1px solid #E1E8F7;border-radius:14px;padding:16px 18px">' + (isIOS ? ios : and) + '</div>'
      + '<button type="button" data-sheet-close style="width:100%;margin-top:16px;padding:14px;border:0;border-radius:13px;background:#0E1B4D;color:#fff;font:700 14px/-apple-system,sans-serif;cursor:pointer;min-height:50px">Entendido</button>'
      + '</div>';
    document.body.appendChild(ov);
    requestAnimationFrame(function(){ ov.style.opacity='1'; var s=ov.querySelector('[data-sheet]'); if(s) s.style.transform='none'; });
    function close(){ ov.style.opacity='0'; setTimeout(function(){ ov.remove(); }, 320); }
    ov.addEventListener('click', function(e){ if (e.target === ov || e.target.closest('[data-sheet-close]')) close(); });
  }

  /* Delegación global: cualquier botón [data-epic-install-app] instala */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-epic-install-app]');
    if (b) { e.preventDefault(); API.installApp(); }
  });
  /* Oculta botones de instalar si ya está en modo app */
  function syncInstallButtons(){
    if (API.isStandalone()) document.querySelectorAll('[data-epic-install-app]').forEach(function(b){ b.hidden = true; });
  }

  /* ── Conector Klaviyo reutilizable (a prueba de errores) ──
     EpicKlaviyo.subscribe(key, list, email, props) → suscribe + dispara flujos.
     No bloquea nada si falla o si no está configurado. */
  window.EpicKlaviyo = {
    /* add(email, props) — usa la config global EPIC_KLAVIYO (key/list públicos). */
    add: function(email, props){
      var cfg = window.EPIC_KLAVIYO || {};
      this.subscribe(cfg.key, cfg.list, email, props);
    },
    subscribe: function(key, list, email, props){
      var cfg = window.EPIC_KLAVIYO || {};
      key = key || cfg.key; list = list || cfg.list;   /* fallback global */
      if (!key || !list || !email || email.indexOf('@') < 1) return;
      try {
        if (lsGet('epicKlaviyoDone_' + email, false)) return; /* no repetir */
        var attrs = { email: email };
        if (props && typeof props === 'object') attrs.properties = props;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'App EPIC', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
        }).then(function(){ lsSet('epicKlaviyoDone_' + email, true); }).catch(function(){});
      } catch(e){}
    }
  };

  window.EpicApp = API;
  function init(){ reveal(); syncInstallButtons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
